<template>
  <div>
    <div class="appui">
      <div class="appui-head">
        <div>
          <h1 class="appui-title">Sorteios</h1>
          <div class="appui-crumb">App <span class="sep">/</span> Sorteios</div>
        </div>
      </div>

      <!-- Vazio -->
      <div v-if="!list.length" class="appui-emptystate">
        <div class="appui-emptystate-icon"><i class="bx bx-trophy"></i></div>
        <div class="appui-emptystate-title">Nenhum sorteio ainda</div>
        <div class="appui-emptystate-sub">Crie sorteios de prêmios — automáticos (todos concorrem) ou por inscrição pelo app.</div>
        <button class="appui-btn appui-btn--primary" @click="openCreate()">+ Criar o primeiro sorteio</button>
      </div>

      <!-- Bloco principal -->
      <section v-else class="appui-card appui-card--flush">
        <div class="appui-card-toolbar">
          <div class="appui-card-toolbar-left">
            <span class="appui-toolbar-hint"><i class="mdi mdi-trophy-outline"></i> "Sortear agora" encerra o sorteio e define os ganhadores na hora.</span>
          </div>
          <div class="appui-card-toolbar-right">
            <button class="appui-btn appui-btn--primary" @click="openCreate()">+ Novo sorteio</button>
          </div>
        </div>

        <div class="appui-grid-3" style="padding:16px">
          <div v-for="r in list" :key="r.id" class="appui-raffle-card" :class="{ done: r.status === 2 }">
            <div class="appui-raffle-photo">
              <img v-if="r.photo" :src="r.photo">
              <i v-else class="bx bx-gift"></i>
              <span class="appui-badge appui-raffle-status" :class="statusBadge(r.status)">{{ statusLabel(r.status) }}</span>
            </div>
            <div style="padding:14px 16px">
              <div style="display:flex;align-items:center;gap:8px;margin-bottom:4px">
                <span style="font-weight:600;font-size:13.5px;color:#495057">{{ r.name }}</span>
                <span class="appui-badge appui-badge--blue">{{ r.type_raffle === 2 ? 'Inscrição' : 'Automático' }}</span>
              </div>
              <div style="font-size:12px;color:#74788d;min-height:18px;margin-bottom:8px">{{ r.description || '' }}</div>
              <div style="display:flex;gap:14px;font-size:11.5px;color:#74788d;margin-bottom:10px;flex-wrap:wrap">
                <span v-if="r.type_raffle === 2"><i class="mdi mdi-account-multiple-outline"></i> {{ r.qty_participants || 0 }} inscritos</span>
                <span><i class="mdi mdi-trophy-outline"></i> {{ r.winners_qty }} {{ r.winners_qty > 1 ? 'prêmios' : 'prêmio' }}</span>
                <span v-if="r.date_raffle"><i class="mdi mdi-calendar-clock"></i> {{ fmtDate(r.date_raffle) }}</span>
              </div>
              <div v-if="(r.winners || []).length" class="appui-raffle-winners">
                <div class="appui-label" style="margin-bottom:5px">🏆 Ganhadores</div>
                <div style="display:flex;flex-wrap:wrap;gap:5px">
                  <span v-for="w in r.winners" :key="w.id" class="appui-badge appui-badge--green">{{ w.name }}</span>
                </div>
              </div>
              <div style="display:flex;gap:8px;margin-top:12px">
                <button v-if="r.status !== 2" class="appui-btn appui-btn--primary appui-btn--sm" @click="draw(r)"><i class="mdi mdi-trophy"></i> Sortear agora</button>
                <button class="appui-tbtn" @click="openEdit(r)">Editar</button>
                <button class="appui-tbtn appui-tbtn--danger" @click="remove(r)">Excluir</button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <b-modal v-model="showModal" :title="form.id ? 'Editar sorteio' : 'Novo sorteio'" size="lg" hide-footer>
      <form @submit.prevent="save()">
        <div class="row">
          <div class="col-sm-4">
            <label class="appui-label">Foto do prêmio</label>
            <input type="file" accept="image/*" ref="photo" style="display:none" @change="onPhoto">
            <div class="appui-drop" :class="{ 'has-img': preview }" style="min-height:150px" @click="$refs.photo.click()">
              <template v-if="preview">
                <img :src="preview" class="appui-drop-img">
                <div class="appui-drop-overlay"><span class="appui-drop-btn"><i class="mdi mdi-swap-horizontal"></i> Trocar</span></div>
              </template>
              <template v-else>
                <i class="mdi mdi-cloud-upload-outline appui-drop-icon"></i>
                <span class="appui-drop-title">Clique para enviar</span>
                <span class="appui-drop-hint">Quadrada · até 4 MB</span>
              </template>
            </div>
          </div>
          <div class="col-sm-8">
            <div class="form-group"><label>Nome *</label><input type="text" class="form-control" v-model="form.name" required></div>
            <div class="form-group"><label>Descrição</label><textarea class="form-control" rows="2" v-model="form.description"></textarea></div>
            <div class="row">
              <div class="form-group col-sm-6">
                <label>Tipo *</label>
                <select class="custom-select" v-model.number="form.type_raffle">
                  <option :value="1">Automático (todos concorrem)</option>
                  <option :value="2">Por inscrição no app</option>
                </select>
              </div>
              <div class="form-group col-sm-6"><label>Qtd. de ganhadores *</label><input type="number" class="form-control" v-model.number="form.winners_qty" min="1" required></div>
            </div>
            <div class="form-group">
              <label>Data programada do sorteio</label>
              <input type="datetime-local" class="form-control" v-model="form.date_raffle">
              <small class="text-muted">Opcional — você também pode usar "Sortear agora" na listagem.</small>
            </div>
          </div>
        </div>
        <div class="text-right"><button type="button" class="btn btn-light mr-2" @click="showModal = false">Cancelar</button><button type="submit" class="btn btn-primary" :disabled="saving">Salvar</button></div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { errorMessage, successMessage } from '@/components/alertsMessages'
import services from './services'
import './app-ui.css'

const empty = () => ({ id: null, name: '', description: '', type_raffle: 1, winners_qty: 1, date_raffle: '' })

export default {
  components: {},
  name: 'app-raffles',
  data () {
    return { list: [], showModal: false, saving: false, form: empty(), photoFile: null, preview: null }
  },
  mounted () { this.load() },
  methods: {
    load () {
      const l = this.$loading.show()
      services.listRaffles().then(r => { this.list = r.data.data }).catch(() => errorMessage('Falha ao carregar.', 3000)).finally(() => l.hide())
    },
    statusLabel (s) { return s === 2 ? 'Concluído' : (s === 1 ? 'Em andamento' : 'Aguardando') },
    statusBadge (s) { return s === 2 ? 'appui-badge--green' : (s === 1 ? 'appui-badge--blue' : 'appui-badge--muted') },
    fmtDate (d) {
      if (!d) return ''
      const dt = new Date(String(d).replace(' ', 'T'))
      if (isNaN(dt)) return d
      return dt.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
    },
    openCreate () { this.form = empty(); this.photoFile = null; this.preview = null; this.showModal = true },
    openEdit (r) {
      this.form = { ...empty(), ...r, date_raffle: r.date_raffle ? String(r.date_raffle).replace(' ', 'T').slice(0, 16) : '' }
      this.photoFile = null
      this.preview = r.photo || null
      this.showModal = true
    },
    onPhoto (e) {
      const f = e.target.files[0]
      e.target.value = ''
      if (!f) return
      if (!f.type.startsWith('image/')) { errorMessage('Envie um arquivo de imagem.', 2500); return }
      if (f.size > 4 * 1024 * 1024) { errorMessage('A imagem deve ter no máximo 4 MB.', 2500); return }
      this.photoFile = f
      this.preview = URL.createObjectURL(f)
    },
    async save () {
      this.saving = true
      try {
        const fd = new FormData()
        ;['name', 'description', 'type_raffle', 'winners_qty'].forEach(k => { if (this.form[k] != null && this.form[k] !== '') fd.append(k, this.form[k]) })
        if (this.form.date_raffle) fd.append('date_raffle', this.form.date_raffle.replace('T', ' ') + ':00')
        if (this.photoFile) fd.append('photo', this.photoFile)
        if (this.form.id) await services.updateRaffle(this.form.id, fd)
        else await services.createRaffle(fd)
        this.showModal = false
        successMessage('Sorteio salvo.', 2000)
        this.load()
      } catch (e) { errorMessage('Falha ao salvar.', 3000) } finally { this.saving = false }
    },
    async draw (r) {
      const ok = await this.$bvModal.msgBoxConfirm(`Sortear ganhador(es) de "${r.name}"? Isso encerra o sorteio.`, { title: 'Sortear agora', okTitle: 'Sortear', cancelTitle: 'Cancelar', okVariant: 'success' })
      if (!ok) return
      try {
        const res = await services.drawRaffle(r.id)
        successMessage('🏆 ' + res.data.data.map(w => w.name).join(', '), 5000)
        this.load()
      } catch (e) { errorMessage(e?.response?.data?.message || 'Falha ao sortear.', 3000) }
    },
    async remove (r) {
      const ok = await this.$bvModal.msgBoxConfirm(`Remover "${r.name}"?`, { okTitle: 'Remover', cancelTitle: 'Cancelar', okVariant: 'danger' })
      if (!ok) return
      try { await services.deleteRaffle(r.id); this.load() } catch (e) { errorMessage('Falha ao remover.', 3000) }
    }
  }
}
</script>
